import { PrimaryCTA } from "./PrimaryCTA";
import asciiHand from "../assets/hero-hand-ascii.json";

type AsciiSegment = { text: string; color: string | null };
type AsciiHand = { cols: number; rows: number; rows_data: AsciiSegment[][] };
const ascii = asciiHand as AsciiHand;

const MARQUEE_ITEMS = [
  "UNLIMITED PRODUCT DESIGN",
  "AI-NATIVE OUTPUT",
  "ONE FLAT MONTHLY FEE",
];

function MarqueeRow() {
  return (
    <>
      {MARQUEE_ITEMS.map((item, i) => (
        <span key={`m-${i}`} className="hero-marquee-item">
          <span>{item}</span>
          <span className="hero-marquee-star" aria-hidden="true">✶</span>
        </span>
      ))}
    </>
  );
}

export function Hero() {
  return (
    <section className="hero" id="top" aria-label="N801 Studio">
      <div className="hero-marquee" aria-hidden="true">
        <div className="hero-marquee-track">
          <MarqueeRow />
          <MarqueeRow />
          <MarqueeRow />
          <MarqueeRow />
        </div>
      </div>

      <div className="hero-card">
        <div className="hero-stage">
          <h1 className="hero-wordmark" data-reveal>
            <span className="sr-only">N801</span>
            <img src="/assets/hero-n801.svg" alt="" aria-hidden="true" />
          </h1>

          <div className="hero-captions" data-reveal>
            <p className="hero-caption hero-caption--left">
              We're an AI-Native digital creative studio
            </p>
            <p className="hero-caption hero-caption--right">
              Based in Salt Lake City, Utah. Est 2026.
            </p>
          </div>
        </div>

        <div className="hero-graffiti-wrap" data-reveal>
          <img
            className="hero-graffiti"
            src="/assets/hero-studio.svg"
            alt=""
            aria-hidden="true"
          />
        </div>

        <div className="hero-hand-wrap" data-reveal>
          <pre className="hero-hand" aria-hidden="true">
            {ascii.rows_data.map((row, y) => (
              <span key={y} className={`hero-hand-row hero-hand-row-${y}`} data-row={y}>
                {row.map((seg, x) =>
                  seg.color ? (
                    <span key={x} style={{ color: seg.color }}>{seg.text}</span>
                  ) : (
                    seg.text
                  ),
                )}
                {"\n"}
              </span>
            ))}
          </pre>
        </div>

        <p className="hero-tagline" data-reveal>
          Unlimited AI-native product design for ambitious startups
        </p>

        <div className="hero-ctas" data-reveal>
          <PrimaryCTA />
        </div>
      </div>
    </section>
  );
}
